const oMatchMedia = window.matchMedia;

window.matchMedia = (query) => {
    const mql = oMatchMedia(query);

    if (!mql.addEventListener) {
        mql.addEventListener = (evName, handler) => {
            mql.addListener(handler);
        };
        mql.removeEventListener = (evName, handler) => {
            mql.removeListener(handler);
        };
    }

    return mql;
};
